export default {"src":"/_next/static/media/whats-app-logo.20b702b2.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};